import { render, staticRenderFns } from "./WelcomeBonusModal.vue?vue&type=template&id=1d2ddf8f&scoped=true&"
import script from "./WelcomeBonusModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeBonusModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeBonusModal.vue?vue&type=style&index=0&id=1d2ddf8f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ddf8f",
  null
  
)

export default component.exports